<template>
  <!--登录之后修改用户密码-->
  <div class="logPassword">
    <div class="content_wrap">
      <div class="warp">
        <div class="password_main">
          <div class="password_main_top ft24">
            <span class="second_font">修改密码</span>
            <span class="fr firstTipComir">首次使用请先修改密码 </span>
          </div>
          <div class="password_center marginTop30">
            <div class="password_item clearfix">
              <label class="password_item_l"><i>*</i>当前账号：</label>
              <div
                class="password_item_r userAccount ft14"
                v-text="userNameLocal"
              ></div>
            </div>
            <div class="password_item clearfix">
              <label class="password_item_l"><i>*</i>新密码：</label>
              <div class="info_item password_item_r">
                <input
                  type="password"
                  placeholder="请输入您的密码"
                  v-model="loginNewPas"
                />
              </div>
            </div>
            <div class="password_item clearfix mt20">
              <label class="password_item_l"><i>*</i>确认新密码：</label>
              <div class="info_item password_item_r">
                <input
                  type="password"
                  placeholder="请确认您的新密码"
                  v-model="loginComPsd"
                />
              </div>
            </div>
          </div>
          <div class="password_main_btns">
            <a href="javascript:;" class="blueComfir_btn" @click="confirmFunc"
              >确认修改</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JSEncrypt from "../assets/js/jsencrypt";

export default {
  name: "logChangePassword",
  data() {
    return {
      userNameLocal: "", //本地取得账号
      initPassword: "", //本地取得原来的密码
      loginNewPas: "", // 用户输入新密码
      loginComPsd: "" // 用户输入确认新密码
    };
  },
  methods: {
    confirmFunc() {
      const that = this;
      let logChangeparams = {
        username: this.userNameLocal, //用户名
        password: this.initPassword, //原密码
        newPassword: this.loginNewPas, //新密码
        confirmPsd: this.loginComPsd //确认新密码
      };
      if (this.check.calibration(logChangeparams)) {
        if (this.loginNewPas != this.loginComPsd) {
          this.$Message.error({
            content: "两次输入的密码不一致，请重新输入！",
            duration: 2
          });
        } else {
		var encrypt = new JSEncrypt();
          encrypt.setPublicKey(
            "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJw/nF+v0qHYsf5TxSVN97iHMydfBEsfCAVSSBSvxXtcWOOZN3fpeNoH9P5KPpxF9+BVrAynIV4dIFgRhE58aRECAwEAAQ=="
		  );
		  logChangeparams.username = encrypt.encrypt(this.userNameLocal);
		  logChangeparams.password = encrypt.encrypt(this.initPassword);
		  logChangeparams.newPassword = encrypt.encrypt(this.loginNewPas);
		  logChangeparams.confirmPsd = encrypt.encrypt(this.loginComPsd);
          this.http.post("/ystOpenPlatformBff/resetPwd", logChangeparams, res => {
            console.log(res);
            if (res.success) {
              this.$Message.success("修改密码成功！");
              this.$router.push({ path: "login" }); //成功之后跳转到登录界面
            } else {
              this.$Message.error("修改失败，请重新修改！");
            }
          });
        }
      }
    }
  },
  mounted() {
    //相当于document.ready后执行的方法 ，DOM元素全部都加载完成之后执行的方法
    this.userNameLocal = sessionStorage.getItem("userName"); //session取得的用户名
    this.initPassword = sessionStorage.getItem("passWord"); //session取得的密码
  }
};
</script>

<style lang="scss">
.content_wrap {
  padding: 30px 0;
}
.firstTipComir {
  font-size: 14px;
  color: $subcolor;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/page/LogChangePassword.vue